import { render, staticRenderFns } from "./pos-change-owner-modal.vue?vue&type=template&id=8bd47996&scoped=true&"
import script from "./pos-change-owner-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-change-owner-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd47996",
  null
  
)

export default component.exports